import {SettingsPageModel} from "./settings-page-model";

export class SettingsInputElementModel extends SettingsPageModel {
}
